import React from 'react';
import { useTranslation } from 'react-i18next';
import '../Styles/Contact.scss';

const Contact = () => {
  const { t } = useTranslation();

  return (
    <section className="contact" id="contact">
      <h2 className="contact__title">{t('contact.title')}</h2>
      <p className="contact__text">{t('contact.text')}</p>
      <ul className="contact__menu">
        <li className="contact__menu-item">
          <a
            href="https://www.linkedin.com/in/benjatestaferrig/"
            className="contact__menu-link"
            target="_blank"
            rel="noreferrer"
            title={t('header.linkedin')}
          >
            <small>benjatestaferrig</small>
            <i className="fab fa-linkedin-in contact__menu-link-icon"></i>
          </a>
        </li>
        <li className="contact__menu-item">
          <a
            href="https://github.com/benjatestaferri7/"
            className="contact__menu-link"
            target="_blank"
            rel="noreferrer"
            title={t('header.github')}
          >
            <small>benjatestaferri7</small>
            <i className="fab fa-github contact__menu-link-icon"></i>
          </a>
        </li>
        <li className="contact__menu-item">
          <a
            href="mailto:benjamintestaferrig@gmail.com"
            className="contact__menu-link"
            target="_blank"
            rel="noreferrer"
            title="Email"
          >
            <small>benjamintestaferrig@gmail.com</small>
            <i className="far fa-envelope contact__menu-link-icon"></i>
          </a>
        </li>
        <li className="contact__menu-item">
          <a
            href="https://twitter.com/benjatg7"
            className="contact__menu-link"
            target="_blank"
            rel="noreferrer"
            title={t('header.twitter')}
          >
            <small>benjatg7</small>
            <i className="fab fa-twitter contact__menu-link-icon"></i>
          </a>
        </li>
      </ul>
    </section>
  );
};

export default Contact;
